import * as React from "react";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import { useNavigate } from "react-router-dom";
import { useForm } from "../hooks";
import { isRequired } from "../hooks/useForm";
import {  PosizionamentoContext } from "../contexts";
import { useContext } from "react";
import { Search } from "@mui/icons-material";
import { MagMovimTable } from "../components";
import {  
  Button,
  IconButton,
  InputAdornment,

} from "@mui/material";
import AddIcon from '@mui/icons-material/Add';

const CAUSALE_ENTRATA = "ent";

const MagLogEntrata = () => {
  let navigate = useNavigate();
  const inputRef = React.useRef();
  

const {
    state:{
        RicercaColumns,
        RicercaMovimenti,
    },
    getRicercaMagMovimenti,
    getMagMovimDataEntrata,
    
} = useContext(PosizionamentoContext);

  const validations = [
    ({ code }) => isRequired(code) || { code: "*Barcode obbligatorio" },
  ];

  React.useEffect(() => {
    setTimeout(() => {
      inputRef.current.focus();
    }, 100);

    getRicercaMagMovimenti(CAUSALE_ENTRATA);

  }, []);

  const {
    values: barcodeForm,
    changeHandler,
    touched,
    errors,
    isValid,
  } = useForm(
    {
      code: "",
    },
    validations
  );



  const onkeyEnter = (event) => {
    if (event === 13) {
      inputRef.current.blur();
      if (barcodeForm.code && isValid) {
        getMagMovimDataEntrata(barcodeForm.code, navigate);
      }
    }
  }; 

  return (
    <>

      <Stack direction={"row"} spacing={2} m={2}>

        <TextField
          id="outlined-basic"
          label="Barcode"
          variant="outlined"
          placeholder="Inserire il barcode"
          fullWidth
          autoFocus
          autoComplete="off"
          inputRef={inputRef}
          /* onClick={()=> inputRef.current.blur()}
              onDoubleClick={()=> inputRef.current.focus()} */
          onKeyPress={(e) => onkeyEnter(e.charCode)}
          onChange={(e) => changeHandler("code", e.target.value)}
          error={Boolean(touched.code && errors.code)}
          //helperText={touched.code && errors.code}
          value={barcodeForm.code || ""}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton color="primary" disabled={!isValid}>
                  <Search />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </Stack>


      <MagMovimTable 
        columnsData={RicercaColumns} 
        rowsData={RicercaMovimenti} 
        navigate={navigate} 
        causale={CAUSALE_ENTRATA} 
        detailFunc={getMagMovimDataEntrata} 
        detailPath={"merce-mag-log-entrata-dettaglio"}
      />
              

    </>
  );
};
export default MagLogEntrata;